import React from 'react';
import type {Sorting} from '../../../bff/types';
import {useAppModel, useProductSearch} from '../../contexts';
import {Select as SortBySelect} from '../sort-by-select';
import type {SelectProps} from '../sort-by-select';
import styles from './model-filter-v2.module.scss';

type ModelFilterV2Props = {
  onClick?: () => void;
  sortByButton: {
    label: string;
    onChange: SelectProps['onChange'];
    value: string;
    options: {
      label: string;
      value: Sorting;
    }[];
  };
};

export const ModelFilterV2: React.FunctionComponent<ModelFilterV2Props> = ({
  onClick,
  sortByButton,
}) => {
  const {appModel} = useAppModel();
  const {facets, toggleFilterOption} = useProductSearch();

  const modelFacet = facets.find((facet) => facet.id === `model`);

  // if (!modelFacet || !appModel) {
  //   return null;
  // }

  const allFilterActive =
    modelFacet?.options.filter((option) => option.selected).length !== 1;

  const clearModelFilterV2 = () => {
    modelFacet?.options.forEach((option) => {
      if (!option.selected) return;
      toggleFilterOption({
        facetId: option.facetId,
        id: option.id,
        selected: false,
      });
    });
    if (onClick) onClick();
  };

  return (
    <div role="tablist" className={styles.modelTab}>
      <button
        className={`${styles.tabButton} ${
          allFilterActive ? styles.active : ``
        }`}
        onClick={clearModelFilterV2}
      >
        <span className={styles.textWrapper}>
          {appModel?.modelTabAllModels}
        </span>
      </button>

      {modelFacet?.options.map((option) => {
        const isActive = option.selected && !allFilterActive;

        const onOptionClick = () => {
          if (isActive) return;
          clearModelFilterV2();
          toggleFilterOption({
            facetId: option.facetId,
            id: option.id,
            selected: true,
          });
          if (onClick) onClick();
        };

        return (
          <button
            key={option.id}
            id={`${option.id}-control`}
            aria-controls={`${option.id}-panel`}
            aria-selected={isActive}
            disabled={option.disabled}
            className={`${styles.tabButton} ${isActive ? styles.active : ``}`}
            role="tab"
            onClick={onOptionClick}
          >
            <span className={styles.textWrapper}>{option.displayName}</span>
          </button>
        );
      })}
      <SortBySelect
        className={styles.sortBySelect}
        autoComplete="on"
        id="sort-by"
        name="sort-by"
        {...sortByButton}
      />
    </div>
  );
};
